var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPdfFile = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5.563h6.767l4.17 4.17V14.81c0 .898-.729 1.627-1.627 1.627H2.69c-.898 0-1.627-.729-1.627-1.627V2c0-.794.643-1.437 1.437-1.438z",
    fill: "#fff",
    stroke: "#91919E",
    strokeWidth: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5h4.444c.067 0 .1-.08.053-.128L9.128.128A.075.075 0 009 .181v4.444c0 .207.168.375.375.375z",
    fill: "#91919E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8,
    width: 9,
    height: 5,
    rx: 0.75,
    fill: "#DD4848"
  })));
};
export default SvgPdfFile;